import DefaultPostIcon from '@modules/publisher/assets/posts-icon-default.svg'
import HoverPostIcon from '@modules/publisher/assets/posts-icon-hover.svg'
import DefaultProfileIcon from '@modules/publisher/assets/profile-icon-default.svg'
import HoverProfileIcon from '@modules/publisher/assets/profile-icon-hover.svg'
import BrandIcon from '@modules/publisher/assets/branding.svg'
import StrategyIcon from '@modules/publisher/assets/strategy.svg'
import TopicsIcon from '@modules/publisher/assets/topics.svg'
import DesignIcon from '@modules/publisher/assets/design.svg'
import DefaultVideoIcon from '@modules/publisher/assets/videos-default.svg'
import HoverVideoIcon from '@modules/publisher/assets/videos-hover.svg'
import DefaultArticleIcon from '@modules/publisher/assets/article-default.svg'
import HoverArticleIcon from '@modules/publisher/assets/article-hover.svg'
import DefaultBulkUploadIcon from '@modules/publisher/assets/bulk-upload-default.svg'
import HoverBulkUploadIcon from '@modules/publisher/assets/bulk-upload-hover.svg'
import DefaultEvergreenIcon from '@modules/publisher/assets/evergreen-default.svg'
import HoverEvergreenIcon from '@modules/publisher/assets/evergreen-hover.svg'
import DefaultRSSIcon from '@modules/publisher/assets/rss-default.svg'
import HoverRSSIcon from '@modules/publisher/assets/rss-hover.svg'
import DefaultSocialIcon from '@modules/publisher/assets/social-default.svg'
import HoverSocialIcon from '@modules/publisher/assets/social-hover.svg'
import DefaultPlannerIcon from '@modules/publisher/assets/planner-icon-default.svg'
import HoverPlannerIcon from '@modules/publisher/assets/planner-icon-hover.svg'
import DefaultContentCategoryIcon from '@modules/publisher/assets/content-categories-default.svg'
import HoverContentCategoryIcon from '@modules/publisher/assets/content-categories-hover.svg'
import SocialDefaultIcon from '@src/modules/publisher/assets/social-default.svg'
import SocialHoverIcon from '@src/modules/publisher/assets/social-hover.svg'
import BlogDefaultIcon from '@src/modules/publisher/assets/blog-default.svg'
import BlogHoverIcon from '@src/modules/publisher/assets/blog-hover.svg'
import SocialAccountDefaultIcon from '@src/modules/publisher/assets/social-account-default.svg'
import SocialAccountHoverIcon from '@src/modules/publisher/assets/social-account-hover.svg'
import RedirectIcon from '@src/assets/img/analytics/external-link.svg'
export const useIcons = () => {
  return {
    DefaultPostIcon,
    HoverPostIcon,
    DefaultProfileIcon,
    HoverProfileIcon,
    BrandIcon,
    StrategyIcon,
    TopicsIcon,
    DesignIcon,
    DefaultVideoIcon,
    HoverVideoIcon,
    DefaultArticleIcon,
    HoverArticleIcon,
    DefaultBulkUploadIcon,
    HoverBulkUploadIcon,
    DefaultEvergreenIcon,
    HoverEvergreenIcon,
    DefaultRSSIcon,
    HoverRSSIcon,
    DefaultSocialIcon,
    HoverSocialIcon,
    DefaultPlannerIcon,
    HoverPlannerIcon,
    DefaultContentCategoryIcon,
    HoverContentCategoryIcon,
    SocialDefaultIcon,
    SocialHoverIcon,
    BlogDefaultIcon,
    BlogHoverIcon,
    SocialAccountDefaultIcon,
    SocialAccountHoverIcon,
    RedirectIcon
  }
}
